module.exports = __webpack_public_path__ + "img/total_ticket_black.de51e605.png";